export const RESCHEDULE_EVENT_BOOKING_START = 'RESCHEDULE_EVENT_BOOKING_START';

export const RESCHEDULE_EVENT_BOOKING_SUCCESS = 'RESCHEDULE_EVENT_BOOKING_SUCCESS';

export const RESCHEDULE_EVENT_BOOKING_FAILED = 'RESCHEDULE_EVENT_BOOKING_FAILED';
